function Step2FabTournamentContent({
 templateState,
 setTemplateField,

 heroImageFile,
 setHeroImageFile,
 existingHeroImageUrl,
 removeHeroImage,
 setRemoveHeroImage,

 bottomImageOneFile,
 setBottomImageOneFile,
 existingBottomImageOneUrl,
 removeBottomImageOne,
 setRemoveBottomImageOne,

 bottomImageTwoFile,
 setBottomImageTwoFile,
 existingBottomImageTwoUrl,
 removeBottomImageTwo,
 setRemoveBottomImageTwo,

 bottomImageThreeFile,
 setBottomImageThreeFile,
 existingBottomImageThreeUrl,
 removeBottomImageThree,
 setRemoveBottomImageThree,
}) {
 return (
  <div className="card">
   <h2>FAB Tournament Content</h2>

   <label className="field">
    <span>Page Title</span>
    <input
     type="text"
     value={templateState.page_title || ""}
     onChange={(e) =>
      setTemplateField("page_title", e.target.value)
     }
     placeholder="Tournament Eligibility"
    />
   </label>

   <label className="field">
    <span>Section Title</span>
    <input
     type="text"
     value={templateState.section_title || ""}
     onChange={(e) =>
      setTemplateField("section_title", e.target.value)
     }
     placeholder="THE DEETS:"
    />
   </label>

   <label className="field">
    <span>Hero Image</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) =>
      setHeroImageFile(e.target.files?.[0] || null)
     }
    />

    {heroImageFile ? (
     <div className="field-help">
      New image selected: {heroImageFile.name}
     </div>
    ) : null}

    {existingHeroImageUrl ? (
     <div className="field-help">
      Current image: {existingHeroImageUrl}
     </div>
    ) : null}

    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeHeroImage}
      onChange={(e) =>
       setRemoveHeroImage(e.target.checked)
      }
     />
     <span>Remove current image</span>
    </label>
   </label>

   <label className="field">
    <span>Paragraph One</span>
    <textarea
     rows="4"
     value={templateState.intro_paragraph_one || ""}
     onChange={(e) =>
      setTemplateField(
       "intro_paragraph_one",
       e.target.value
      )
     }
     placeholder="FAB’s regular season consists of 8 games..."
    />
   </label>

   <label className="field">
    <span>Paragraph Two</span>
    <textarea
     rows="4"
     value={templateState.intro_paragraph_two || ""}
     onChange={(e) =>
      setTemplateField(
       "intro_paragraph_two",
       e.target.value
      )
     }
     placeholder="At FAB, we do our best to maintain a high-quality league..."
    />
   </label>

   <label className="field">
    <span>Paragraph Three</span>
    <textarea
     rows="4"
     value={templateState.intro_paragraph_three || ""}
     onChange={(e) =>
      setTemplateField(
       "intro_paragraph_three",
       e.target.value
      )
     }
     placeholder="Tournaments are held at all FAB locations..."
    />
   </label>

   <label className="field">
    <span>Paragraph Four</span>
    <textarea
     rows="4"
     value={templateState.intro_paragraph_four || ""}
     onChange={(e) =>
      setTemplateField(
       "intro_paragraph_four",
       e.target.value
      )
     }
     placeholder="To be eligible to play in the tournament..."
    />
   </label>

   <label className="field">
    <span>Paragraph Five</span>
    <textarea
     rows="4"
     value={templateState.intro_paragraph_five || ""}
     onChange={(e) =>
      setTemplateField(
       "intro_paragraph_five",
       e.target.value
      )
     }
     placeholder="The league fee includes playoff entry..."
    />
   </label>

   <label className="field">
    <span>Tournament List Title</span>
    <input
     type="text"
     value={templateState.tournament_list_title || ""}
     onChange={(e) =>
      setTemplateField(
       "tournament_list_title",
       e.target.value
      )
     }
     placeholder="Tournament"
    />
   </label>

   <label className="field">
    <span>Bottom Image One</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) =>
      setBottomImageOneFile(e.target.files?.[0] || null)
     }
    />

    {bottomImageOneFile ? (
     <div className="field-help">
      New image selected: {bottomImageOneFile.name}
     </div>
    ) : null}

    {existingBottomImageOneUrl ? (
     <div className="field-help">
      Current image: {existingBottomImageOneUrl}
     </div>
    ) : null}

    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeBottomImageOne}
      onChange={(e) =>
       setRemoveBottomImageOne(e.target.checked)
      }
     />
     <span>Remove current image</span>
    </label>
   </label>

   <label className="field">
    <span>Bottom Image Two</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) =>
      setBottomImageTwoFile(e.target.files?.[0] || null)
     }
    />

    {bottomImageTwoFile ? (
     <div className="field-help">
      New image selected: {bottomImageTwoFile.name}
     </div>
    ) : null}

    {existingBottomImageTwoUrl ? (
     <div className="field-help">
      Current image: {existingBottomImageTwoUrl}
     </div>
    ) : null}

    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeBottomImageTwo}
      onChange={(e) =>
       setRemoveBottomImageTwo(e.target.checked)
      }
     />
     <span>Remove current image</span>
    </label>
   </label>

   <label className="field">
    <span>Bottom Image Three</span>
    <input
     type="file"
     accept="image/*"
     onChange={(e) =>
      setBottomImageThreeFile(e.target.files?.[0] || null)
     }
    />

    {bottomImageThreeFile ? (
     <div className="field-help">
      New image selected: {bottomImageThreeFile.name}
     </div>
    ) : null}

    {existingBottomImageThreeUrl ? (
     <div className="field-help">
      Current image: {existingBottomImageThreeUrl}
     </div>
    ) : null}

    <label
     style={{
      display: "flex",
      gap: "0.5rem",
      alignItems: "center",
      marginTop: "0.5rem",
     }}
    >
     <input
      type="checkbox"
      checked={removeBottomImageThree}
      onChange={(e) =>
       setRemoveBottomImageThree(e.target.checked)
      }
     />
     <span>Remove current image</span>
    </label>
   </label>
  </div>
 );
}

export default Step2FabTournamentContent;